import validator from 'validator'

import {
  Iris,
  Jsonld,
  Iri,
  Literal,
  DataProperty,
  ObjectProperty,
} from '@/rec-cache/rec-cache-types'

import { RecIndividual } from '@/rec-cache/rec-cache-individual'

// Factory for RDF and OWL types.
class Owl {
  constructor(namespaces) {
    this.namespaces = namespaces
  }

  // Check if an id is an iri within the namespaces. Returns boolean.
  isIri(id) {
    const iri = this.namespaces.expand(id)
    return validator.isURL(iri) == true
  }

  iri(value) {
    const iri = this.namespaces.expand(value)
    return new Iri(iri, this.namespaces)
  }

  literal(value, datatype = Iris.xsdString) {
    return new Literal(value, datatype)
  }

  dataProperty(name, values) {
    return new DataProperty(name, values)
  }

  objectProperty(name, values) {
    return new ObjectProperty(name, values)
  }

  individual() {
    return new RecIndividual(this.namespaces)
  }

  // Parses expanded JSON LD to an OWL individual.
  // Support for application specific RDF namespacing is undertaklen here, ie the Iris are minted (issued) here.
  // TODO combine types, rec individual and owl into one module. Refactor properties to not mint Iris. Must be done beforehand.
  parse(expandedJsonLd) {
    const individual = new RecIndividual()

    Object.entries(expandedJsonLd).forEach(([key, values]) => {
      switch (key) {
        case Jsonld.context:
          // Context disregarded.
          break
        case Jsonld.id:
          // Id is a string.
          individual.id = this.iri(values)
          break
        case Jsonld.type:
          // Type is an array of strings.
          individual.addTypes(...values.map((v) => this.iri(v)))
          break
        default: {
          // Property values are arrays of objects { @value, [ @language ] }
          // Determine if first element is an IRI implying an object property.
          // TODO add support for language...
          const [value] = values
          const name = this.iri(key)

          // TODO temporary handling of JSON literals.
          if (value?.['@type'] == '@json') {
            const property = new DataProperty(name, [
              this.literal('JSON Literal ' + JSON.stringify(value?.['@value'])),
            ])
            individual.addProperties(property)
            break
          }

          // TODO object properties shall be @id not @value but wrong format from WoB...
          const property =
            value?.[Jsonld.value] && validator.isURL(value[Jsonld.value])
              ? this.objectProperty(
                  name,
                  values.map((v) => this.iri(v[Jsonld.value]))
                )
              : this.dataProperty(
                  name,
                  values.map((v) => this.literal(v[Jsonld.value]))
                )
          individual.addProperties(property)
          break
        }
      }
    })

    return individual
  }
}

export { Owl }
